<div class="more-comments--wrapper {{ type }}">
  <ng-container *ngIf="!loading">
    <ark-icon icon="system-down" color="cta" size="small"></ark-icon>
    <span
      >{{
        'COMPONENTS.POST_MORE_COMMENTS.MORE_' +
          (type === 'comment' ? 'COMMENTS' : 'REPLIES') | translate
      }}
      ({{ metadata.commentsDisplayed }}
      {{ 'COMPONENTS.POST_MORE_COMMENTS.OF' | translate }}
      {{ metadata.commentsTotal }})</span
    >
  </ng-container>
  <ark-loader-inline *ngIf="loading"></ark-loader-inline>
</div>
